import { render, staticRenderFns } from "./reo-td.vue?vue&type=template&id=2ddcdb35&scoped=true&"
import script from "./reo-td.vue?vue&type=script&lang=js&"
export * from "./reo-td.vue?vue&type=script&lang=js&"
import style0 from "./reo-td.vue?vue&type=style&index=0&id=2ddcdb35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcdb35",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddcdb35')) {
      api.createRecord('2ddcdb35', component.options)
    } else {
      api.reload('2ddcdb35', component.options)
    }
    module.hot.accept("./reo-td.vue?vue&type=template&id=2ddcdb35&scoped=true&", function () {
      api.rerender('2ddcdb35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/result-components/reo_table/reo-td.vue"
export default component.exports